export const actions = {
  setMasquaradeUsers: 'SET_MASQUARADE_USERS',
  setMasquaradeUser: 'SET_MASQUARADE_USER',
};

export function setMasquaradeUsers(masquaradeUsers, masquaradeUserCount) {
  return { type: actions.setMasquaradeUsers, masquaradeUsers, masquaradeUserCount };
}

export function setMasquaradeUser(isMasquaraded) {
  return { type: actions.setMasquaradeUser, isMasquaraded };
}

const INITIAL_STATE = {
  masquaradeUsers: [],
  masquaradeUserCount: 0,
  isMasquaraded: false,
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.setMasquaradeUsers:
      return {
        ...state,
        masquaradeUsers: action.masquaradeUsers,
        masquaradeUserCount: action.masquaradeUserCount,
      };
    case actions.setMasquaradeUser:
      return {
        ...state,
        isMasquaraded: action.isMasquaraded,
      };
    default:
      return { ...state };
  }
}
